function EventCard() {
    return (
        <div
            // key={id}
            className="eventContainer"
        >
            {/* <div onClick={onClick}> */}
            <div>
                <h2 className="eventHeading">Eventname: Kina</h2>
                <p className="eventText">Eventart: Kina</p>
                <p className="eventText">Todo: Liste (Anzahl)</p>
                <p className="eventText">Einkauf: Liste (Anzahl)</p>
            </div>
        </div>
    );
}

export default EventCard;